// jshint strict: false

function template(strings, ...keys) {
  return (...values) => {
    const dict = values[values.length - 1] || {};
    const result = [strings[0]];
    keys.forEach((key, i) => {
      const value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });
    return result.join('');
  };
}

const location_atm_list = template`<div class="location-cell type-atm">
  <div class="location-heading">
    <div class="location-type">
      <svg class="icon" viewBox="0 0 24 24">
        <use xlink:href="#locations_atm"></use>
      </svg>
      ATM
    </div>

    <div class="location-distance">
      ${'distance'}
    </div>
  </div>

  <div class="location-content">
    <h3 class="h4">${'title'}</h3>

    <div class="location-info">
      <div class="grid-cell">
        <div class="h6">Address</div>
        <p>${'address'}</p>
        <a href="${'directions'}">Get Directions</a>
      </div>

      <div class="grid-cell">
        <div class="h6">Available Services</div>
        <ul>
          <li>Surcharge-Free ATM</li>
          <li>Public Access ATM</li>
        </ul>
      </div>
    </div>
  </div>
</div>`;

const location_atm_tooltip = template`<div class="location-cell type-atm">
  <button class="close icon-only" aria-label="Close marker tooltip"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#close"></use></svg></button>
  <div class="location-content">
    <h3 class="h4">${'title'}</h3>

    <div class="h6">Address</div>
    <p>${'address'}</p>
    <a href="${'directions'}">Get Directions</a>
  </div>
</div>`;

const location_branch_list = template`<div class="location-cell type-branch">
  <div class="location-heading">
    <div class="location-type">
      <svg class="icon" viewBox="0 0 24 24">
        <use xlink:href="#locations_branch"></use>
      </svg>
      Branch
    </div>

    <div class="location-distance">
      ${'distance'}
    </div>
  </div>

  <div class="location-closed${'closed'}">
    Temporarily Closed
  </div>

  <div class="location-content">
    <h3 class="h4"><a href="${'permalink'}">${'title'}</a></h3>

    <div class="location-info">
      <div class="grid-cell">
        <div class="h6">Address</div>
        <p>${'address'}</p>
        <a href="${'directions'}">Get Directions</a>
      </div>
      <div class="grid-cell">
        <div class="h6">Lobby Hours</div>
        <p>${'lobby_hours'}</p>

        <div class="h6">Drive-Thru Hours</div><p>${'drive_thru_hours'}</p>
      </div>
    </div>
  </div>
</div>`;

const location_branch_tooltip = template`<div class="location-cell type-branch">
  <button class="close icon-only" aria-label="Close marker tooltip"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#close"></use></svg></button>

  <div class="location-closed${'closed'}">
    Temporarily Closed
  </div>

  <div class="location-content">
    <h3 class="h4"><a href="${'permalink'}">${'title'}</a></h3>

    <div class="h6">Address</div>
    <p>${'address'}</p>
    <a href="${'directions'}">Get Directions</a>
  </div>
</div>`;